import React from 'react';
import {
  useFormContext,
  Controller,
  FieldErrorsImpl,
  DeepRequired,
  FieldValues
} from 'react-hook-form';
import { TextField } from '@material-ui/core';

type TProps = {
  name: any;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  type?: string;
  errorMessage?: React.ReactNode;
  multiline?: boolean;
  rows?: number;
  style?: any;
  defaultValue?: string;
  fullWidth?: boolean;
  onChange?: any;
  maxLength?: number;
  emailValidation?: RegExp;
};

export const AppTextfield: React.VFC<TProps> = React.memo((props: TProps) => {
  // react-hook-fomrを使用する前提のcomponent
  const { register, control } = useFormContext();
  const height = 34;
  const labelOffset = -8;

  // https://mui.com/components/text-fields/#main-content の必要なpropsを追加する
  const {
    name,
    label,
    required = false,
    disabled,
    type,
    errorMessage,
    multiline,
    rows,
    style,
    defaultValue,
    fullWidth = false,
    onChange,
    maxLength,
    emailValidation
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...register(name, {
            required: {
              value: required, // required=trueのpropsがある場合にバリデーション有効
              message: '必須です。'
            },
            maxLength: maxLength && {
              // maxLengthがpropsにある場合にバリデーション有効
              value: maxLength,
              message: `${maxLength}文字以内で入力してください。`
            },
            pattern: emailValidation && {
              // emailValidationがpropsにある場合にバリデーション有効
              value: emailValidation,
              message: 'メールアドレスの形式が正しくありません。'
            }
          })}
          fullWidth={fullWidth}
          disabled={disabled}
          margin='none'
          autoComplete='off'
          error={errorMessage !== undefined} // errorMessageがあればエラーのスタイルを適用
          helperText={errorMessage}
          type={type}
          multiline={multiline}
          defaultValue={defaultValue}
          rows={rows}
          variant='outlined'
          placeholder={label}
          style={style}
          onChange={onChange}
          InputLabelProps={{
            style: {
              height,
              top: `${labelOffset}px`
            }
          }}
          inputProps={{
            style: {
              height,
              padding: '0 14px'
            },
            maxLength: maxLength
          }}
        />
      )}
    />
  );
});
